import React, { Component } from 'react';

import { StyleSheet, css } from 'aphrodite';

export class ComingSoon extends Component {
  render() {
    return (
      <p className={css(Styles.nfMiddle)}>Coming Soon !</p>
    );
  }
}

const Styles = StyleSheet.create({
  nfMiddle: {
    fontSize: 20,
    paddingTop: '15%',
    textAlign: 'center'
  }
})


// WEBPACK FOOTER //
// ./src/screens/ComingSoon.js